import {all} from "redux-saga/effects";
import watcherDoubleCounter from "./doubleCounter_saga";
import watcherAuthentication from "./auth.saga";
import watcherAuthenticationTutor from "./tutorAuth.saga";
import watcherData from "./data.saga";
import watcherQuestionnaireSaga from "./questionnaire.saga";
import watcherProfile from "./profile.saga";

export default function* rootSaga() {
  yield all([
    watcherDoubleCounter(),watcherAuthentication(),watcherAuthenticationTutor(),watcherData(),watcherQuestionnaireSaga(),watcherProfile()
  ]);
}
